import "./EanInventory.scss";

export default function EanInventory() {
  return (
    <section className="sales-layout__page ean-inventory">
      <h1>EAN Inventur</h1>
      <p>Hier wird zukünftig die Inventur anhand von EANs durchgeführt.</p>
    </section>
  );
}
